import { Skeleton } from "@/components/ui/skeleton";
import { TableCell, TableRow } from "@/components/ui/table";

export function TableSkeletonRows({ rows = 8, columns }: { rows?: number; columns: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static placeholders
        <TableRow key={r} aria-hidden>
          {Array.from({ length: columns }, (_, c) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: static placeholders
            <TableCell key={c}>
              <Skeleton className="h-4" style={{ width: `${45 + ((r * 7 + c * 13) % 45)}%` }} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
